
import { useI18n } from "vue-i18n"
import { useRoute } from "vue-router"
import cookies from "js-cookie"

export default {
  props: ["active", "equipmentId"],
  setup() {
    const { t } = useI18n()
    const route = useRoute()
    let openId = route.query.openid?.toString() || null
    if (openId) {
      cookies.set("openId", openId) // 100年
    } else {
      openId = cookies.get("openId")?.toString() || null
    }

    return { openId }
  }
}
